module.exports = __webpack_public_path__ + "static/media/homepage2.b2a98969.png";